const client = new WebSocket("wss://zvswg3jc1m.execute-api.us-east-1.amazonaws.com/dev");


export default function createWebsocketPlugin() {
    return store => {
        store.dispatch('addClientConnection', client);
        store.state.client.onopen = function (e) {

            console.log("onopenooooo");
            console.log(e);
            store.dispatch('connectionOpened');
            console.log("SATTETETETET", store.state);

            if (store.state.teacherId != null && store.state.teacherId != "") {
                store.commit("SEND_MESSAGE", {
                    data: { teacherId: store.state.teacherId, classId: store.state.currentClass.classId, sessionId: store.state.currentSession.sessionId },
                    opCode: store.state.opCodes.TryRejoin,
                });
            }

        };
        store.state.client.onerror = function (error) {
            console.error("onerror!!!!!", error);
            console.dir(error);
            store.dispatch('connectionError');
        };
        store.state.client.onclose = function () {
            console.error("onclose");
            store.dispatch('connectionClosed');
        };
        store.state.client.onmessage = function (e) {
            console.log("message received", e.data);
            store.dispatch('connectionMessage', e.data);
        };
        store.subscribe((mutation, state) => {
            console.log(state.connected, mutation.type)
            if (state.connected && mutation.type === 'SEND_MESSAGE') {
                console.log("message sent here", mutation.payload.data, mutation.payload.opCode)
                store.state.client.send(JSON.stringify(
                    {
                        action: "message",
                        data: mutation.payload.data,
                        opCode: mutation.payload.opCode
                    }
                ))
            }
        });
    }
}